import { notFound } from '@tanstack/react-router'
import { PortalMode, usePortalModeStore } from '@stores/usePortalModeStore'

export type RouteAudience = readonly PortalMode[]

export function requireRouteAudience(allowedAudiences: RouteAudience) {
    return () => {
        const viewMode = usePortalModeStore.getState().viewMode

        if (!allowedAudiences.includes(viewMode)) {
            throw notFound()
        }
    }
}
